import {
  MerchantEmailCampaignStatsSchema,
  MerchantEmailConfigSchema,
} from "@redotech/redo-model/merchant-email-config";
import * as z from "zod/v4";

export const getMerchantEmailConfigs = {
  name: "getMerchantEmailConfigs" as const,
  input: z.object({}),
  output: z.object({
    campaigns: z.array(MerchantEmailConfigSchema),
    stats: z.array(MerchantEmailCampaignStatsSchema),
  }),
};
